import React from 'react'
import { ProjectContextType } from './projectTypes'

export const ProjectContext = React.createContext<ProjectContextType | undefined>(undefined)
